import { FC, useState } from "react";
import { useTranslation } from "i18n";
import { dataTestIds } from "data-testids";
import { Input } from "../../../../../Molecules/Input/Input";
import { InputSearchIcon } from "../../../../../Atoms/InputsCommon/InputSearchIcon";
import {
  ICheckboxGroupValue,
  CheckboxGroup,
} from "../../../../CheckboxGroup/CheckboxGroup";
import { IDropdownCheckboxValueItemConfig } from "../../../../../../components/Molecules/DropdownCheckbox/DropdownCheckboxValue";
import { IFilterValues } from "../../../../Filters/types";
import { InputCleaner } from "../../../../../Atoms/InputsCommon/InputCleaner";
import "./AppearanceFilterDrawer.scss";

export interface IAppearanceFilterDrawerProps {
  name: string;
  fieldOptions: IDropdownCheckboxValueItemConfig[];
  filterDrawerValue: ICheckboxGroupValue;
  onSetFilterValues: (values: Partial<IFilterValues>) => void;
}

function filterFieldOptionsByLabel(
  appearanceSearchTerm: string,
  fieldOptions: IDropdownCheckboxValueItemConfig[]
): IDropdownCheckboxValueItemConfig[] {
  if (!appearanceSearchTerm) {
    return fieldOptions;
  }

  return fieldOptions.filter((option) =>
    option.label.toLowerCase().includes(appearanceSearchTerm.toLowerCase())
  );
}

const AppearanceFilterDrawer: FC<IAppearanceFilterDrawerProps> = ({
  fieldOptions,
  name,
  filterDrawerValue,
  onSetFilterValues,
}) => {
  const { t } = useTranslation();
  const [appearanceSearchTerm, setAppearanceSearchTerm] = useState("");

  const localFieldOptions = filterFieldOptionsByLabel(
    appearanceSearchTerm,
    fieldOptions
  );

  const hasNoOptions =
    Boolean(!localFieldOptions.length) && Boolean(appearanceSearchTerm);

  const handleCleanClick = () => {
    setAppearanceSearchTerm("");
  };

  return (
    <>
      <Input
        className="appearance-filter-drawer"
        type="text"
        placeholder={t("common:search.filters.placeholder.search")}
        value={appearanceSearchTerm}
        notifying={hasNoOptions}
        isFormSubmitted={true}
        validationMessage={t("common:search.filters.validation")}
        onChange={(e) => setAppearanceSearchTerm(e.target.value)}
        data-testid={
          dataTestIds.componentLibrary[
            "Organisms.Filters.FilterFields.AppearanceFilter.AppearanceFilterDrawer.searchInput"
          ]
        }
      >
        <InputSearchIcon />
        {appearanceSearchTerm && <InputCleaner onClick={handleCleanClick} />}
      </Input>
      <CheckboxGroup
        config={{ name, options: localFieldOptions }}
        value={filterDrawerValue}
        valueChanged={(value) => {
          onSetFilterValues({ [name]: value });
        }}
      />
    </>
  );
};

export default AppearanceFilterDrawer;
